import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { UserProfile } from '../apiTypes';
import { fetchUserProfile, updateSNSData, updateUserProfile } from './actions';
import type { UserProfileState } from './types';

const initialState: UserProfileState = {
  data: {} as UserProfile,
  loading: false,
  error: null,
  nicknameDraft: '',
  isSnsDataUpdating: false,
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: initialState,
  reducers: {
    setUserProfile(state, action: PayloadAction<UserProfile>) {
      state.data = action.payload;
    },
    setNicknameDraft(state, action: PayloadAction<string>) {
      state.nicknameDraft = action.payload;
    },
    clearNicknameDraft(state) {
      state.nicknameDraft = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to Fetch';
      })
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to Update';
      })
      .addCase(updateSNSData.pending, (state) => {
        state.isSnsDataUpdating = true;
        state.error = null;
      })
      .addCase(updateSNSData.fulfilled, (state) => {
        state.isSnsDataUpdating = false;
      })
      .addCase(updateSNSData.rejected, (state, action) => {
        state.isSnsDataUpdating = false;
        state.error = action.error.message ?? 'Failed to Update';
      });
  },
});

export const { setUserProfile, setNicknameDraft, clearNicknameDraft } = userProfileSlice.actions;
export const userProfileReducer = userProfileSlice.reducer;
